import { useEffect, useReducer } from 'react';
import { isReloadingForStaleChunk, RELOAD_PENDING_MS } from './chunkReload';

/**
 * Whether a stale-chunk reload is on its way, for the fallbacks to render
 * nothing meanwhile. Re-renders when that expires, so a reload that never
 * happens brings the fallback back instead of leaving the screen blank.
 *
 * `refresh` re-reads the state after the caller asked for a reload itself.
 */
export function useReloadPending(): readonly [pending: boolean, refresh: () => void] {
  const [, refresh] = useReducer((n: number) => n + 1, 0);
  const pending = isReloadingForStaleChunk();

  useEffect(() => {
    if (!pending) return undefined;
    const timer = setTimeout(refresh, RELOAD_PENDING_MS);
    return () => clearTimeout(timer);
  }, [pending]);

  return [pending, refresh];
}
